<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 text-center">
            <img src="assets/img/404.jpg" class="img-fluid" width="1130px">
        </div>
    </div>
</div>